export function resolveNumericInput(input: string, fallback: number): number {
  const parsed = parseFloat(input);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function mergeThresholdInputs(
  currentThresholds: Record<string, number> | undefined,
  thresholdInputs: Record<string, string>
): Record<string, number> {
  return Object.fromEntries(
    Object.entries(currentThresholds || {}).map(([key, value]) => [
      key,
      resolveNumericInput(thresholdInputs[key] ?? '', value)
    ])
  );
}
